import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
    const { i18n } = useTranslation();

    const languages = [
        { code: 'en', label: '🇺🇸' },
        { code: 'ko', label: '🇰🇷' },
        { code: 'ja', label: '🇯🇵' },
        { code: 'zh-TW', label: '🇹🇼' },
    ];


    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    const buttonStyle = {
        margin: '0 5px',
        padding: '5px 10px',
        cursor: 'pointer',
        background: 'transparent',
        border: '1px solid #ccc',
        borderRadius: '4px',
        color: 'inherit'
    };

    const activeStyle = {
        ...buttonStyle,
        background: 'rgba(255, 255, 255, 0.2)',
        fontWeight: 'bold',
        borderColor: '#fff'
    };

    return (
        <div className="language-selector" style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
            {languages.map(lang => (
                <button
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    style={i18n.language.startsWith(lang.code) ? activeStyle : buttonStyle}
                >
                    {lang.label}
                </button>
            ))}
        </div>
    );
};

export default LanguageSelector;
